import { Car, Timestamp } from 'src/types'

import carService from 'src/api/carService'

import { UpdateCarProps } from 'src/api/UserCars/types'

export async function getListOfUsersCars(): Promise<Car<Timestamp>[]> {
  return carService.getUserCars()
}

export async function addUserCar(car: Car): Promise<void> {
  return carService.addUserCar(car)
}

export async function setActiveCar(carNumber: string): Promise<void> {
  return carService.setActiveCar(carNumber)
}

export async function updateDataUserCar({
  newData,
  carNumber,
}: UpdateCarProps): Promise<void> {
  return carService.updateDataUserCar(carNumber, newData)
}

export async function deleteUserCar(carNumber: string): Promise<string> {
  return carService.deleteUserCar(carNumber)
}
